import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetRequestSummaryEstimation_Booking$key } from "./__generated__/useGetRequestSummaryEstimation_Booking.graphql";

export const useGetRequestSummaryEstimation = ({
  fragmentRef,
}: {
  fragmentRef: useGetRequestSummaryEstimation_Booking$key | null;
}) => {
  const data = useFragment(
    useGetRequestSummaryEstimationFragmentString,
    fragmentRef
  );

  const totalNineHolePrice =
    data?.startSlot?.slotRates?.reduce(
      (sum, rate) => sum + (rate?.nineHolePrice || 0),
      0
    ) || 0;
  const totalEighteenHolePrice =
    data?.startSlot?.slotRates?.reduce(
      (sum, rate) => sum + (rate?.eighteenHolePrice || 0),
      0
    ) || 0;

  return {
    totalNineHolePrice,
    totalEighteenHolePrice,
  } as const;
};

export const useGetRequestSummaryEstimationFragmentString = graphql`
  fragment useGetRequestSummaryEstimation_Booking on Booking {
    startSlot {
      ... on QueueSlot {
        slotRates: playerRates(type: CUSTOMER, highestPrecedentOnly: true) {
          nineHolePrice: totalGolfPrice(holeCount: NINE)
          eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)
        }
      }
    }
  }
`;
